import type { CSSProperties } from "react";
import {
  TABLE_COL_GRIP_HEIGHT_PX,
  TABLE_COL_GRIP_WIDTH_PX,
  TABLE_ROW_GRIP_HEIGHT_PX,
  TABLE_ROW_GRIP_WIDTH_PX,
} from "./constants";
import type { AxisFocus, LineDragVisual, TableCtx } from "./types";

export function buildRowGripStyle(ctx: TableCtx, lineDragVisual: LineDragVisual | null): CSSProperties | null {
  if (lineDragVisual?.kind === "row") {
    /** 行左竖向格线为中点（与首列左缘对齐） */
    const lineX = lineDragVisual.row.left;
    return {
      position: "fixed",
      left: lineX - TABLE_ROW_GRIP_WIDTH_PX / 2,
      top:
        lineDragVisual.row.top +
        lineDragVisual.row.height / 2 -
        TABLE_ROW_GRIP_HEIGHT_PX / 2 +
        lineDragVisual.offsetY,
      width: TABLE_ROW_GRIP_WIDTH_PX,
      height: TABLE_ROW_GRIP_HEIGHT_PX,
      zIndex: 231,
    };
  }
  const lineX = ctx.rowRect.left;
  return {
    position: "fixed",
    left: lineX - TABLE_ROW_GRIP_WIDTH_PX / 2,
    top: ctx.rowRect.top + ctx.rowRect.height / 2 - TABLE_ROW_GRIP_HEIGHT_PX / 2,
    width: TABLE_ROW_GRIP_WIDTH_PX,
    height: TABLE_ROW_GRIP_HEIGHT_PX,
    zIndex: 228,
  };
}

export function buildColGripStyle(ctx: TableCtx, lineDragVisual: LineDragVisual | null): CSSProperties | null {
  if (lineDragVisual?.kind === "col") {
    /** 列顶横向格线为中点 */
    const lineY = lineDragVisual.col.top;
    return {
      position: "fixed",
      left:
        lineDragVisual.col.left +
        lineDragVisual.col.width / 2 -
        TABLE_COL_GRIP_WIDTH_PX / 2 +
        lineDragVisual.offsetX,
      top: lineY - TABLE_COL_GRIP_HEIGHT_PX / 2,
      width: TABLE_COL_GRIP_WIDTH_PX,
      height: TABLE_COL_GRIP_HEIGHT_PX,
      zIndex: 231,
    };
  }
  const lineY = ctx.columnTopRect.top;
  return {
    position: "fixed",
    left: ctx.columnTopRect.left + ctx.columnTopRect.width / 2 - TABLE_COL_GRIP_WIDTH_PX / 2,
    top: lineY - TABLE_COL_GRIP_HEIGHT_PX / 2,
    width: TABLE_COL_GRIP_WIDTH_PX,
    height: TABLE_COL_GRIP_HEIGHT_PX,
    zIndex: 228,
  };
}

export function buildAxisFocusOverlayStyle(
  axisOverlayGeom: TableCtx | null,
  axisFocus: AxisFocus | null,
  lineDragVisual: LineDragVisual | null,
): CSSProperties | null {
  if (!axisOverlayGeom || !axisFocus || lineDragVisual) return null;
  if (axisFocus.kind === "row") {
    return {
      position: "fixed",
      left: axisOverlayGeom.tableRect.left,
      top: axisOverlayGeom.rowRect.top,
      width: axisOverlayGeom.tableRect.width,
      height: axisOverlayGeom.rowRect.height,
      pointerEvents: "none",
      /** 低于斜杠/行列轴菜单（z≈220/240），避免整行整列描边盖住菜单 */
      zIndex: 210,
      boxSizing: "border-box",
    };
  }
  return {
    position: "fixed",
    left: axisOverlayGeom.columnTopRect.left,
    top: axisOverlayGeom.tableRect.top,
    width: axisOverlayGeom.columnTopRect.width,
    height: axisOverlayGeom.tableRect.height,
    pointerEvents: "none",
    zIndex: 210,
    boxSizing: "border-box",
  };
}
